import { render, staticRenderFns } from "./nav-header.vue?vue&type=template&id=407ae57c&scoped=true&"
import script from "./nav-header.vue?vue&type=script&lang=js&"
export * from "./nav-header.vue?vue&type=script&lang=js&"
import style0 from "./nav-header.vue?vue&type=style&index=0&id=407ae57c&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.10.2/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "407ae57c",
  null
  
)

export default component.exports